/*
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.create = options =>
            {
                return new classConstructor({
                    table: options.table,
                    tableRow: options.tableRow
                });
            };
        }
*/
import { JNative, JNativeStatic } from "../../JNative";
import { PartialNullable } from "../../Extensions";
import { Property } from "../../RadObject";
import { ITableCellBase, TableCellBase, TableCellBasePropertyValues, TableCellCreateOptions } from "./Table";
import { NAMESPACE } from "./_Namespace";

export type TableCellEntitySaveIndicatorPropertyValues =
    TableCellBasePropertyValues
    & {
    };

export type TableCellEntitySaveIndicatorProperties = {
    [name in keyof TableCellEntitySaveIndicatorPropertyValues]: Property<TableCellEntitySaveIndicatorPropertyValues[name]>
};

export interface ITableCellEntitySaveIndicator extends ITableCellBase, TableCellEntitySaveIndicatorProperties
{
}

export class TableCellEntitySaveIndicator extends TableCellBase implements ITableCellEntitySaveIndicator
{
    // #region Static

    public static override classNamespace = NAMESPACE + "TableCellEntitySaveIndicator";
    public static override className = "TableCellEntitySaveIndicator";

    // #endregion

    // #region Instance

    // #region Global Variables

    protected $$saveIndicator?: JNative<HTMLElement>;

    // #endregion

    // #region Constructor

    constructor(propertyValues?: PartialNullable<TableCellEntitySaveIndicatorPropertyValues>)
    {
        super(propertyValues);

        this.addCssClass("rad-control-table-cell-entity-save-indicator");
    }

    // #endregion

    // #region Overrides

    protected override _createElement()
    {
        const
            $$element = super._createElement();

        this.$$saveIndicator =
            JNativeStatic.create$$({
                nodeName: "i",
                attributes: { "class": "rad-save-indicator icon" }
            });

        this.append(this.$$saveIndicator);

        this._contentsElementRef.current.hide();

        return $$element;
    }

    // #endregion

    // #endregion
}

